export const buildProvenance = { "commitHash": "95fe43689a2b8040d85831d5d54969fcbeb21c13", "branchName": "refs/heads/release/2025.4", "buildDate": "2026-02-19T04:25:03.050Z", "version": "2025.4.10446" };
